import { render } from "./AdsFilter.vue?vue&type=template&id=4b83bc82&ts=true"
import script from "./AdsFilter.vue?vue&type=script&lang=ts"
export * from "./AdsFilter.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__